import React from 'react';

export default () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
       <path d='M6 4l20 12-20 12z' />
    </svg>

);
